import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange} from "@angular/core";
declare const $;

@Component({
  selector: 'app-advance-game',
  templateUrl: './advance-game.component.html',
  styleUrls: ['./advance-game.component.css']
})
export class AdvanceGameComponent implements OnChanges, OnDestroy, OnInit {
  @Input() characterSpeech: any;
  @Input() sceneCharacters: any;
  @Input() sceneAudios : any;
  @Input() reactions : any;
  @Input() selectedScene : any;
  @Input() influence : any;
  @Input() master_feedback : any;
  @Input() isGameRestart : boolean;
  @Input() isAudioLoadFlag : boolean;
  @Input() disableGameResponse : any;
  @Input() audioPath : any;
  @Input() lastThreeResponse : string;
  @Input() selectedGameResponse : string;
  @Input() influenceCounter: number;
  @Input() lastScore: Array<number>;
  @Input() resConfig : any;
  @Input() usrGameCfgData : any;
  @Input() no_of_attempts : any;
  @Input() screenOrientataion : any;
  @Output() loadTextMsg = new EventEmitter<any>();
  @Output() feedbackResponse = new EventEmitter<any>();
  @Output() gameFinished = new EventEmitter<any>();
  @Output() lastScoreSave = new EventEmitter<any>();
  @Output() gameResponseDisable = new EventEmitter<any>();
  @Output() playGlobalAudio = new EventEmitter<any>();
  @Output() feedBackCFGText = new EventEmitter<any>();
  @Output() isDisplayNotificationDivText = new EventEmitter<any>();
  playResponseAudioFlag: boolean = true;
  expressionIndex = 0;
  audioForIndex = 0;
  defaultExpressionInterval: any;
  roundScore : Array<any> = [];
  influenceSection : boolean = false;
  FeedbackInfluence : boolean = false;
  FeedbackPonder : boolean = false;
  count = 1;
  x = 0;
  myScore = 0;
  characterScore = 0;
  teamScore = 0;
  intervalsArray = [];
  timeOutsArray = [];
  playedAudiosArray = [];
  isLastNode: boolean = false;
  summaryFeedback: any;
  responseDisable;
  ponderText: string;
  influenceText: string;
  prevScore: Array<number> = [];
  currentGameChoices: Array<any> = [];
  feedbackCounter: number = 0;
  selectedInfluence: any;
  selectedFeedback: any;
  feedbackAudio: any;
  influenceAudio: any;
  isInfluence: boolean = true;
  isMasterFeedback: boolean = false;
  influenceScore: any;
  randonNum: number;
  characterName = '';
  isInfluenceEnabled : boolean = true;
  cfgFeedBackFlag : boolean = false;
  isCfgFeedBackInvalid : boolean = false;
  cfgFeedBackText: any;
  cfgContinueData: any;
  screenWidth : number = 1366;
  screenHeight : number;

  constructor() { }

  ngOnInit(){
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
  }

  ngOnChanges(changes : { [propertyName: string]: SimpleChange }){
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    console.log("this.screenOrientataion: ", this.screenOrientataion);
    this.expressionIndex = 0;
    this.isLastNode = false;
    this.FeedbackInfluence = false;
    this.FeedbackPonder = false;
    this.isMasterFeedback = false;
    this.clearAllIntervals();
    if(this.isGameRestart){
      this.isGameRestart = false;
      this.cfgFeedBackFlag = false;
      this.isDisplayNotificationDivText.emit({flag: true});
      this.currentGameChoices = [];
      if(this.lastScore.length > 0){
        this.prevScore[0]  = JSON.parse(JSON.stringify(this.lastScore[0]));
        this.prevScore[1]  = JSON.parse(JSON.stringify(this.lastScore[1]));
        this.prevScore[2]  = JSON.parse(JSON.stringify(this.lastScore[2]));
      }else {
        this.prevScore[0]  = this.myScore;
        this.prevScore[1]  = this.characterScore;
        this.prevScore[2]  = this.teamScore;
      }
      this.roundScore = [];
      this.myScore = 0;
      this.characterScore = 0;
      this.teamScore = 0;
      this.isInfluenceEnabled = true;
      this.animateScore('.myScore',0,"", ()=>{});
      this.animateScore('.characterScore',0, "",()=>{});
      this.animateScore('.teamScore',0,"", ()=>{});
      //this.disableGameResponse = 'false';
    }
    this.responseDisable = this.disableGameResponse == 'true' ? true : false;
    console.log("------------disableGameResponse---------------");
    console.log(this.disableGameResponse);
    this.randonNum = this.generateRandomNumber(0, 101);
    this.FeedbackPonder = false;
    this.influenceSection = false;
    this.isInfluence = true;
    this.influenceCounter++;
    this.feedbackCounter++;
    this.influenceScore = undefined;
    $("#"+this.characterSpeech.rootId).empty();
    $("#"+this.characterSpeech.rootId).css('background-image','url('+this.sceneCharacters.bgImage.src+')');
    let c,clist;
    clist=this.characterSpeech.characterSpeech;
    let charId="myimg0";
    let ctooltipId="tooltip01";
    $("#"+this.characterSpeech.rootId).append('<div><div id="'+charId+'"><div class="parentboxAdv"><div id="'+ctooltipId+'" class="speech-bubbleAdv childbox"><div class="tooltip-content-wrapper">"'+this.characterSpeech.characterSpeech[0].text+'"</div></div></div></div></div>');
    $("#"+ctooltipId).css("display","inline-block");
    $("#"+charId).css('background-image','url('+ this.sceneCharacters[clist[0].name+'_'+clist[0].expression[this.expressionIndex]].src+')');
    $("#"+charId).css('height','320px');
    $("#"+charId).css('width','100%');
    $("#"+charId).css('background-position','0% 38%');
    $("#"+charId).css('position','absolute');
    $("#"+charId).css('left','-12%');
    //$("#"+ctooltipId).html("<div class='tooltip-content-wrapper'>"+this.characterSpeech.characterSpeech[0].text+"</div>");
    $('#myimg0').addClass('myimg0_Adv');
    this.characterName = this.characterSpeech.characterSpeech[0].name;
    this.x = 0;
    this.count = 1;
    let frames = this.characterSpeech.characterSpeech[0].frames[0];
    let fidelity = this.characterSpeech.characterSpeech[0].fidelity[0];
    $("#"+this.characterSpeech.rootId).append('<div class="advNarratorDialogue"></div>');
    $('.advNarratorDialogue').css('display','none');
    this.setInetrvalAn(charId, 0,  frames, fidelity);
    this.loadScene();
  }

  setInetrvalAn(charId, c, width, fidelity){
    let fps = 1000/fidelity;
    this.defaultExpressionInterval = setInterval(()=>{
      this.playSpriteImage(charId, width);
    }, fps);
  }

  ngAfterViewInit(){
    let top = document.getElementById('top');
    if(top){
      top.scrollIntoView();
      top=null;
    }
  }

  playSpriteImage(id, width){
    $("#"+id).css('background-position',''+this.x+'px 38%');
    if(this.count == width-1){
      this.x = 0;
      this.count = 1;
    }else{
      this.count = this.count+1;
      this.x = this.x-960;
    }
  }

  loadScene(){
    this.expressionIndex = 1;
    this.audioForIndex = 0;
    if(this.characterSpeech.options.length == 0)
      this.responseDisable = true;

    this.playResponseAudioFlag = false;
    this.gameResponseDisable.emit({response: this.responseDisable});
    $("#tooltip0").css("display","none");
    if(this.characterSpeech.narratorsDialog.narrator){
      this.narratorCharacterPlay();
    }else {
      clearInterval(this.defaultExpressionInterval);
      $("#tooltip0").css("display","inline-block");
      this.playCharacter(0);
    }
  }

  playCharacter(audioNum){
    // this.responseDisable = true;
    this.gameResponseDisable.emit({response: this.responseDisable});
    let charId="myimg0";
    let ctooltipId="tooltip0";
    let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+this.characterSpeech.characterSpeech[0].expression[this.expressionIndex]].src;
    let Frames = this.characterSpeech.characterSpeech[0].frames[this.expressionIndex];
    let Fidelity = this.characterSpeech.characterSpeech[0].fidelity[this.expressionIndex];
    // true if audio is there.
    let isAudio = this.characterSpeech.characterSpeech[0].audioFor.indexOf(this.expressionIndex.toLocaleString()) != -1;
    // total no of expression for character.
    let totalExpressions = this.characterSpeech.characterSpeech[0].expression.length;
    $("#"+ctooltipId).text(this.characterSpeech.characterSpeech[0].text);
    if($("#"+ctooltipId).height() > 170){
      $("#"+ctooltipId).css('font-size', '12px');
    }
    if($("#"+ctooltipId).height() > 170){
      $("#"+ctooltipId).css('font-size', '11px');
    }
    if($("#"+ctooltipId).height() > 170){
      $("#"+ctooltipId).css('font-size', '10px');
    }
    if(isAudio){
      let name = this.characterSpeech.characterSpeech[0].audioFile[audioNum];
      let duration;
      if(name && this.sceneAudios[name.split(".")[0]]){
        duration = this.sceneAudios[name.split(".")[0]].duration * 1000;
        /*this.sceneAudios[name.split(".")[0]].currentTime = 0;
        this.sceneAudios[name.split(".")[0]].play();*/
        this.playGlobalAudio.emit({name: this.sceneAudios[name.split(".")[0]]});
        this.playedAudiosArray.push(this.sceneAudios[name.split(".")[0]]);
      }else {
        // duration = 5000;

        let txtForCnt = this.characterSpeech.characterSpeech[0].text;
        let textLength = txtForCnt.length;
        if(textLength > 0){
          if(textLength < 8){
            let lowText = ((textLength / 2) * 1000) >= 1000 ? (textLength / 2) * 1000 : 750;
            duration = lowText;
            console.log("textLength---",textLength,"duration", duration);
          }else{
            let lowText = ((textLength / 8) * 1000) > 1000 ? (textLength / 8) * 1000 : 750;
            // duration = ((lowText / wordsPerMinute) * 60000) >= 1000 ? ((lowText / wordsPerMinute) * 60000) : lowText;
            duration = lowText;
            console.log("textLength---",textLength,"duration", duration);
          }
        }else{
          duration = 5000;
          console.log("textLength",textLength,"duration", duration);
        }
      }

      this.expressionWithAudio(charId, url, Frames, duration, Fidelity, ()=>{
        this.expressionIndex++;
        if(this.expressionIndex != totalExpressions){
          audioNum++;
          this.playCharacter(audioNum);
        }else {
          $("#preloaderModal").css('display', 'none');
          this.loadTextMsg.emit({flag: 'game'});
          this.responseDisable = false;
          this.playResponseAudioFlag = true;
          this.gameResponseDisable.emit({response: this.responseDisable});
          if(this.screenOrientataion == 90 && this.screenWidth < 1000){
            $('.responseBgContainer').css('top','0%');
          }
          let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+this.characterSpeech.characterSpeech[0].expression[0]].src;
          let Frames = this.characterSpeech.characterSpeech[0].frames[0];
          let Fidelity = this.characterSpeech.characterSpeech[0].fidelity[0];
          let defaultExp = this.characterSpeech.characterSpeech[0].defaultExpression;
          if(defaultExp == "true")
            this.defaultExpression(charId, url, Frames, Fidelity);

          let lastChar = this.characterSpeech.title.charAt(this.characterSpeech.title.length - 1);
          if(this.influenceCounter >3 && lastChar == "2"&& this.isInfluenceEnabled){
            for(let i=0; i< this.influence.influencingOption.length; i++){
              if(this.influence.influencingOption[i].path == this.lastThreeResponse){
                this.selectedInfluence = this.influence.influencingOption[i];
                this.isInfluence = false;
                break;
              }
            }
          }
          if(this.feedbackCounter && this.feedbackCounter > 3){
            let path = this.selectedGameResponse.slice(this.selectedGameResponse.length-7, this.selectedGameResponse.length);

            for(let i=0; i< this.master_feedback.mastersFeedback.length; i++){
              if(this.master_feedback.mastersFeedback[i].Path == path && this.master_feedback.mastersFeedback[i].text != ''){
                this.selectedFeedback = this.master_feedback.mastersFeedback[i];
                this.isMasterFeedback = true;
                this.feedbackCounter = 0;
                let name = this.master_feedback.mastersFeedback[i].audio;
                let file = this.sceneAudios[name.split(".")[0]];
                if(file){
                  /*file.currentTime = 0;
                  file.play();*/
                  this.playGlobalAudio.emit({name: file});
                  this.playedAudiosArray.push(file);
                  this.feedbackAudio = file;
                }
                break;
              }
            }
          }
        }
      });
    }else {
      this.expressionWithoutAudio(charId, url, Frames, Fidelity, ()=>{
        this.expressionIndex++;
        if(this.expressionIndex != totalExpressions){
          audioNum++;
          this.playCharacter(audioNum);
        }else {
          $("#preloaderModal").css('display', 'none');
          this.loadTextMsg.emit({flag: 'game'});
          this.responseDisable = false;
          this.playResponseAudioFlag = true;
          this.gameResponseDisable.emit({response: this.responseDisable});
          if(this.screenOrientataion == 90 && this.screenWidth < 1000){
            $('.responseBgContainer').css('top','0%');
          }
          let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+this.characterSpeech.characterSpeech[0].expression[0]].src;
          let Frames = this.characterSpeech.characterSpeech[0].frames[0];
          let Fidelity = this.characterSpeech.characterSpeech[0].fidelity[0];
          let defaultExp = this.characterSpeech.characterSpeech[0].defaultExpression;
          if(defaultExp == "true")
            this.defaultExpression(charId, url, Frames, Fidelity);

          let lastChar = this.characterSpeech.title.charAt(this.characterSpeech.title.length - 1);

          if(this.influenceCounter >3 && lastChar== "2" && this.isInfluenceEnabled){
            for(let i=0; i< this.influence.influencingOption.length; i++){
              if(this.influence.influencingOption[i].path == this.lastThreeResponse){
                this.selectedInfluence = this.influence.influencingOption[i];
                this.isInfluence = false;
                break;
              }
            }
          }
          if(this.feedbackCounter && this.feedbackCounter > 3){
            let path = this.selectedGameResponse.slice(this.selectedGameResponse.length-7, this.selectedGameResponse.length);
            for(let i=0; i< this.master_feedback.mastersFeedback.length; i++){
              if(this.master_feedback.mastersFeedback[i].Path == path && this.master_feedback.mastersFeedback[i].text != ''){
                this.selectedFeedback = this.master_feedback.mastersFeedback[i];
                this.isMasterFeedback = true;
                this.feedbackCounter = 0;
                let name = this.master_feedback.mastersFeedback[i].audio;
                let file = this.sceneAudios[name.split(".")[0]];
                if(file){
                  /*file.currentTime = 0;
                  file.play();*/
                  this.playGlobalAudio.emit({name: file});
                  this.playedAudiosArray.push(file);
                  this.feedbackAudio = file;
                }
                break;
              }
            }
          }
        }
      });
    }
  }

  generateRandomNumber(min, max) {
    let random_number = Math.random() * (max - min) + min;
    return Math.floor(random_number);
  }
  slideScorecard(){
    $(".arrowAnimate").toggleClass("arrowIn");
    $(".scorecardSlideWrapper").toggleClass("slideFull");
  }

  playReactionAnimation(fileName, expression, text, frames, x, randonNum, isEndOfGame, i, score, Fidelity){
    var charId="myimg0";
    var ctooltipId="tooltip0";
    let file = this.sceneAudios[fileName];
    let duration;
    this.clearAllIntervals();
    if(file){
      duration = file.duration * 1000;
      /*file.currentTime = 0;
      file.play();*/
      this.playGlobalAudio.emit({name: file});
      this.playedAudiosArray.push(file);
    }else
      duration = 1000;

    $("#"+ctooltipId).text(text);
    $("#"+ctooltipId).css("display","inline-block");
    let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+ expression].src;
    if(file){
        this.expressionWithAudio(charId, url, frames, duration, Fidelity, ()=>{

        let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+this.characterSpeech.characterSpeech[0].expression[0]].src;
        let Frames = this.characterSpeech.characterSpeech[0].frames[0];
        let Fidelity = this.characterSpeech.characterSpeech[0].fidelity[0];
        this.defaultExpression(charId, url, Frames, Fidelity);
        this.roundScore.push({myScore : parseInt(score[0]), characterScore : parseInt(score[1]), team : (parseInt(score[0]) + parseInt(score[1]))});
          this.calculateScore(isEndOfGame, x, i, randonNum);
      });
    }else {
      this.expressionWithAudio(charId, url, frames, 1500, Fidelity, ()=>{

        let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+this.characterSpeech.characterSpeech[0].expression[0]].src;
        let Frames = this.characterSpeech.characterSpeech[0].frames[0];
        let Fidelity = this.characterSpeech.characterSpeech[0].fidelity[0];
        this.defaultExpression(charId, url, Frames, Fidelity);
        this.roundScore.push({myScore : parseInt(score[0]), characterScore : parseInt(score[1]), team : (parseInt(score[0]) + parseInt(score[1]))});
        this.calculateScore(isEndOfGame, x, i, randonNum);
      });
    }
  }

  responseClick(i){
    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      $('.responseBgContainer').css('top','100%');
    }
    $(".scorecardSlideWrapper").removeClass('slideFull');
    $(".arrowAnimate").removeClass('arrowIn');
    this.responseDisable = true;
    this.gameResponseDisable.emit({response: this.responseDisable});
    if(i.property)
      this.currentGameChoices.push(i.property);

    let prob;
    if(this.influenceScore){
      prob = [];
      prob.push(this.influenceScore);
      let s = 100-this.influenceScore;
      prob.push(s.toLocaleString());
    }else {
      prob = i.prob.split(":");
    }

    this.lastThreeResponse = this.lastThreeResponse+''+i.id[i.id.length-2]+''+i.id[i.id.length-1];
    if(this.lastThreeResponse.length>6)
      this.lastThreeResponse = this.lastThreeResponse.substr(2,this.lastThreeResponse.length);

    let isEndOfGame = i.isEndOfGame ? i.isEndOfGame : "false";
    let score = i.score.split(':');
    let flag = false;
    let number;
    let currentReaction;
    for(let j=0; j< this.reactions.responceReactions.length; j++){
      if(this.reactions.responceReactions[j].score == score[1]){
        flag = true;
        currentReaction = this.reactions.responceReactions[j];
        number = this.generateRandomNumber(0,currentReaction.responce.length);
        break;
      }
    }
    if(flag){
      let file = currentReaction.audios[number].split('.')[0];
      let text = currentReaction.responce[number];
      let expression = currentReaction.expression;
      let frames = currentReaction.frames;
      let Fidelity = currentReaction.fidelity;
      let randomNum = this.generateRandomNumber(0, 101);
      this.playReactionAnimation(file,expression, text, frames, prob, randomNum, isEndOfGame, i, score, Fidelity);
    }
  }

  calculateScore(isEndOfGame, x, i, randonNum){
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;

    let mScore = this.myScore, cScore = this.characterScore, tScore = this.teamScore;
    for(let j=0; j< this.roundScore.length; j++){
      mScore = this.myScore + this.roundScore[j].myScore;
      cScore = this.characterScore + this.roundScore[j].characterScore;
      tScore = this.teamScore + this.roundScore[j].team;
    }
    let uFile = '';
    let cFile = '';
    let tfile = 'scoreClap';
    if(mScore > cScore){
      uFile = 'scoreBeep';
      cFile = 'scoreType';
    }else if (mScore < cScore){
      uFile = 'scoreType';
      cFile = 'scoreBeep';
    } else if(mScore == cScore){
      uFile = 'scoreClap';
      cFile = 'scoreClap';
    }
    this.myScore = mScore;
    this.animateScore('.myScore',this.myScore,uFile, ()=>{
      this.characterScore = cScore;
      this.animateScore('.characterScore',this.characterScore, cFile,()=>{
        this.teamScore = tScore;
        this.animateScore('.teamScore',this.teamScore,tfile, ()=>{

          if(isEndOfGame == "true"){
            let flagNoOp = false;
            if (this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Games && this.resConfig[0].Games.length > 0) {
              if (this.resConfig[0].Games[0].feedback_text && this.resConfig[0].Games[0].feedback_text.visible && this.no_of_attempts == 0) {
                if (this.usrGameCfgData && this.usrGameCfgData.length > 0) {
                  let ind = this.usrGameCfgData.findIndex(obj => obj.name == 'feedback_text');
                  if (ind == -1) {
                    flagNoOp = true;
                  }
                } else {
                  flagNoOp = true;
                }
              }
            }
            if (flagNoOp) {
              this.cfgFeedBackFlag = true;
              this.isDisplayNotificationDivText.emit({flag: false});
              if(this.screenOrientataion == 90 && this.screenWidth < 1000){
                $('.responseBgContainer').css('top','0%');
              }
              let cfgObj = {
                isEndOfGame: isEndOfGame,
                x: x,
                i: i,
                randonNum: randonNum,
              };
              this.cfgContinueData = cfgObj;
            }else{
              this.selectedGameResponse = this.selectedGameResponse.concat(i.id[i.id.length-1]);
              let score = this.myScore+":"+this.characterScore;
              let nextLink;
              if(randonNum < parseInt(x[0]))
                nextLink = 1;
              else
                nextLink = 2;
              this.gameFinished.emit({finished: true, Score: score, Path: i.id, prevScore: this.prevScore, Choice: this.currentGameChoices, Responses: this.selectedGameResponse, influenceCounter: this.influenceCounter, lastThreeResponse: this.lastThreeResponse, nextLink: nextLink});
              this.lastScore[0]  = this.myScore;
              this.lastScore[1]  = this.characterScore;
              this.lastScore[2]  = this.teamScore;
              this.lastScoreSave.emit({lastScore: this.lastScore});
              this.isLastNode = true;
              if(this.screenOrientataion == 90 && this.screenWidth < 1000){
                $(".mobileSlideHeader").removeClass("headerShow");
                $('.responseBgContainer').css('top','0%');
                $('.gameContainer').css('height','calc(100vh - 66px)');
                $('.commonModalFooter').css('display','flex');
              }
              $('.showSingle').removeClass('modalFooterActiveBtn');
              $('#showSingle6').addClass('modalFooterActiveBtn');
              for(let j=0; j< this.characterSpeech.summaryFeedbacks.length; j++){
                if(this.characterSpeech.summaryFeedbacks[j].id == i.id){
                  this.summaryFeedback = this.characterSpeech.summaryFeedbacks[j].text;
                  break;
                }
              }
            }
          }else {
            this.isLastNode = false;
            this.clearAllIntervals();
            if(randonNum < parseInt(x[0])){
              let linkTo = i.id + '1';
              this.selectedGameResponse = this.selectedGameResponse.concat(i.id[i.id.length-1]+'1');
              this.feedbackResponse.emit({linkTo : linkTo, isEndOfGame : isEndOfGame, score : this.roundScore});
            } else {
              let linkTo = i.id + '2';
              this.selectedGameResponse = this.selectedGameResponse.concat(i.id[i.id.length-1]+'2');
              this.feedbackResponse.emit({linkTo : linkTo, isEndOfGame : isEndOfGame, score : this.roundScore});
            }
          }
        });
      });
    });

  }

  animateScore(id,score,fileName, callback){
    let file = this.sceneAudios[fileName];
    let duration;
    if(file) {
      /*file.currentTime = 0;
      file.play();*/
      this.playGlobalAudio.emit({name: file});
      this.playedAudiosArray.push(file);
    }
      $(id).each(function () {
        $(this).prop('Counter',0).animate({
          Counter: score
        }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now));
          }
        });
      });

    let mySetTime = setTimeout(() => {
      if (file) {
        file.pause();
      }
      callback();
    }, 2000);
    this.timeOutsArray.push(mySetTime);
  }

  influenceCall(){
    this.loadTextMsg.emit({flag: 'game'});
    $("#preloaderModal").css('display', 'block');
    let files = [];
    files.push(this.selectedInfluence.pt_audio);
    files.push(this.selectedInfluence.YText_audio);
    files.push(this.selectedInfluence.ZText_audio);
    files.push(this.selectedInfluence.optionY.audio);
    files.push(this.selectedInfluence.optionZ.audio);
    let lang = localStorage.getItem("defaultLang");
    let count =0;
    let that = this;
    if(!this.isAudioLoadFlag){
      $("#preloaderModal").css('display', 'none');
      this.loadTextMsg.emit({flag: 'game'});
      this.influenceSection = true;
    }else{
      this.loadTextMsg.emit({flag: 'audio'});
      for(let i=0; i< files.length; i++){
        if(files[i].split('.')[1] == 'mp3'){
          let audioSource = that.audioPath + files[i];
          let audio = new Audio();
          /*audio.src = this.audioPath + files[i];
          audio.load();
          audio.addEventListener('loadeddata', () => {
            count++;
            let name = files[i].split(".");
            this.sceneAudios[name[0]] = audio;
            if(count == files.length){
              $("#preloaderModal").css('display', 'none');
             this.loadTextMsg.emit({flag: 'game'});
              this.influenceSection = true;
            }
          });
          audio.addEventListener('error', ()=>{
            let newaudio = new Audio();
            let path = this.audioPath.replace(lang,'English');
            newaudio.src = path + files[i];
            newaudio.load();
            newaudio.addEventListener('loadeddata', () => {
              count++;
              let name = files[i].split(".");
              this.sceneAudios[name[0]] = newaudio;
              if(count == files.length){
                $("#preloaderModal").css('display', 'none');
                 this.loadTextMsg.emit({flag: 'game'});
                this.influenceSection = true;
              }
            });
            newaudio.addEventListener('error', ()=>{
              count++;
              if(count == files.length){
                $("#preloaderModal").css('display', 'none');
                this.loadTextMsg.emit({flag: 'game'});
                this.influenceSection = true;
              }
            })
          });*/

          if(audioSource){
            let mediaSource = new MediaSource();
            //audio.crossOrigin="anonymous";
            audio.src = URL.createObjectURL(mediaSource);
            mediaSource.addEventListener('sourceopen', () => {
              URL.revokeObjectURL(audio.src);
              let mime = 'audio/mpeg';
              let sourceBuffer = mediaSource.addSourceBuffer(mime);

              fetch(encodeURI(audioSource))
                .then(function (response) {
                  return response.arrayBuffer();
                })
                .then(function (arrayBuffer) {
                  sourceBuffer.addEventListener('updateend', function (e) {
                    if (!sourceBuffer.updating && mediaSource.readyState === 'open') {
                      mediaSource.endOfStream();
                      count++;
                      let name = files[i].split(".");
                      that.sceneAudios[name[0]] = audio;
                      if(count == files.length){
                        $("#preloaderModal").css('display', 'none');
                        that.influenceSection = true;
                      }
                      // audio.play();
                    }
                  });
                  sourceBuffer.appendBuffer(arrayBuffer);
                })
                .catch(function (error) {
                  console.log("error...", error);
                  console.log(".....", files[i]);

                  let newaudio = new Audio();
                  let path = that.audioPath.replace(lang,'English');
                  let newAudioSrc = path + files[i];

                  let engMediaSource = new MediaSource();
                  //newaudio.crossOrigin="anonymous";
                  newaudio.src = URL.createObjectURL(engMediaSource);
                  engMediaSource.addEventListener('sourceopen', () => {
                    URL.revokeObjectURL(audio.src);
                    let mime = 'audio/mpeg';
                    let sourceBuffer = engMediaSource.addSourceBuffer(mime);

                    fetch(encodeURI(newAudioSrc))
                      .then(function (response) {
                        return response.arrayBuffer();
                      })
                      .then(function (arrayBuffer) {
                        sourceBuffer.addEventListener('updateend', function (e) {
                          if (!sourceBuffer.updating && mediaSource.readyState === 'open') {
                            mediaSource.endOfStream();
                            count++;
                            let name = files[i].split(".");
                            that.sceneAudios[name[0]] = newaudio;
                            if(count == files.length){
                              $("#preloaderModal").css('display', 'none');
                              that.influenceSection = true;
                            }
                            // audio.play();
                          }
                        });
                        sourceBuffer.appendBuffer(arrayBuffer);
                      })
                      .catch(function (error) {
                        console.log("error...", error);
                        console.log(".....", files[i]);
                        count++;
                        if(count == files.length){
                          $("#preloaderModal").css('display', 'none');
                          that.influenceSection = true;
                        }
                      });
                  });
                });
            });
          }else{
            count++;
            if(count == files.length){
              $("#preloaderModal").css('display', 'none');
              this.loadTextMsg.emit({flag: 'game'});
              this.influenceSection = true;
            }
          }
        }
      }
    }
  }

  ponder(){
    this.FeedbackPonder = true;
    let randNum = this.generateRandomNumber(0,this.characterSpeech.ponderTexts.length);
    this.ponderText = this.characterSpeech.ponderTexts[randNum];
  }
  optionSelect(val){
    this.stopInfluenceOptionAudio(this.selectedInfluence, val);
    if(val == 'Y'){
      $('#influceOption1').addClass('influenceOptionHighlight');
      this.influenceText = this.selectedInfluence.optionY;
      this.influenceScore = this.selectedInfluence.optionY.likelihood;

      let name = this.selectedInfluence.optionY.audio.split('.')[0];//this.selectedInfluence.path+"_2"+val;
      if(this.sceneAudios[name]) {
        this.influenceAudio = this.sceneAudios[name];
        /*this.influenceAudio.currentTime = 0;
        this.influenceAudio.play();
        this.influenceAudio.currentTime = 0;*/
        this.playGlobalAudio.emit({name: this.influenceAudio});
        this.playedAudiosArray.push(this.influenceAudio);
      }
    }else {
      $('#influceOption2').addClass('influenceOptionHighlight');
      this.influenceText = this.selectedInfluence.optionZ;
      this.influenceScore = this.selectedInfluence.optionZ.likelihood;
      let name = this.selectedInfluence.optionZ.audio.split('.')[0];
      if(this.sceneAudios[name]) {
        this.influenceAudio = this.sceneAudios[name];
        /*this.influenceAudio.currentTime = 0;
        this.influenceAudio.play();
        this.influenceAudio.currentTime = 0;*/
        this.playGlobalAudio.emit({name: this.influenceAudio});
        this.playedAudiosArray.push(this.influenceAudio);
      }
    }

    this.isInfluence = true;
    //this.influenceCounter = 0;
    //this.lastThreeResponse = '';
    this.isInfluenceEnabled = false;
    this.FeedbackInfluence = true;
  }

  closeInfluence(){
    this.influenceSection = false;
    this.FeedbackInfluence = false;
    this.FeedbackPonder = false;
  }
  continuePonder(){
    this.influenceSection = false;
    this.FeedbackInfluence = false;
    this.FeedbackPonder = false;
  }
  continueInfluence(){
    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      $('.responseBgContainer').css('top','100%');
    }
    this.influenceSection = false;
    this.FeedbackInfluence = false;
    this.FeedbackPonder = false;
    let number;
    if (this.influenceAudio){
      this.influenceAudio.pause();
    }
    if(this.influenceScore){
      let currentInfluence;
      currentInfluence = this.reactions.influenceReactions;
      let randNum = this.generateRandomNumber(0, 101);
      if(randNum <= this.influenceScore){
        number = this.generateRandomNumber(0,currentInfluence.positiveReactions.reaction.length);
        let file = currentInfluence.positiveReactions.audios[number].split('.')[0];
        let text = currentInfluence.positiveReactions.reaction[(number)];
        let expression = currentInfluence.positiveReactions.expression;
        let frames = currentInfluence.positiveReactions.frames;
        let Fidelity = currentInfluence.positiveReactions.fidelity;
        let option = "Positive";
        this.playInfluenceReactionAnimation(file,expression, text, frames, option, Fidelity);
      }else {
        number = this.generateRandomNumber(0,currentInfluence.negativeReactions.reaction.length);
        let file = currentInfluence.negativeReactions.audios[number].split('.')[0];
        let text = currentInfluence.negativeReactions.reaction[(number)];
        let expression = currentInfluence.negativeReactions.expression;
        let frames = currentInfluence.negativeReactions.frames;
        let Fidelity = currentInfluence.negativeReactions.fidelity;
        let option = "Negative";
        this.playInfluenceReactionAnimation(file,expression, text, frames, option, Fidelity);
      }
    }
  }

  playInfluenceReactionAnimation(fileName, expression, text, frames, option, Fidelity){
    var charId="myimg0";
    var ctooltipId="tooltip0";
    let file = this.sceneAudios[fileName];
    let duration;
    this.clearAllIntervals();
    if(file){
      duration = file.duration * 1000;
      /*file.currentTime = 0;
      file.play();*/
      this.playGlobalAudio.emit({name: file});
      this.playedAudiosArray.push(file);
    }else
      duration = 1000;
    $("#"+ctooltipId).text(text);
    $("#"+ctooltipId).css("display","inline-block");
    let url = this.sceneCharacters[this.characterSpeech.characterSpeech[0].name+'_'+ expression].src;
    if(file){
      this.expressionWithAudio(charId, url, frames, duration, Fidelity, ()=>{
        if(option == "Positive"){
          let l = this.selectedScene.length;
          let p;
          if(this.selectedScene.slice(l-1, l) == 1){
            p = this.selectedScene.slice(0, l-1)+""+2;
          }else {
            p = this.selectedScene.slice(0, l-1)+""+1;
          }
          /*this.characterSpeech = null;*/
          this.feedbackResponse.emit({linkTo : p});
        }else
          this.loadScene();
      });
    }else {
      this.expressionWithAudio(charId, url, frames, 1500, Fidelity, ()=>{
        if(option == "Positive"){
          let l = this.selectedScene.length;
          let p;
          if(this.selectedScene.slice(l-1, l) == 1){
            p = this.selectedScene.slice(0, l-1)+""+2;
          }else {
            p = this.selectedScene.slice(0, l-1)+""+1;
          }
          /*this.characterSpeech = null;*/
          this.feedbackResponse.emit({linkTo : p});
        }else
          this.loadScene();
      });
    }
  }


  defaultExpression(charId, url, Frames, fidelity){
    let x = 0;
    let count = 1;
    let fps = 1000/fidelity;
    // start animation with interval
    let myInt1 = setInterval(()=>{
      $("#"+charId).css('background-image','url('+url+')');
      $("#"+charId).css('background-position',''+x+'px 0%');
      if(count == Frames){
        count = 1;
        x = 0;
      }else{
        count = count+1;
        x = x-960;
      }
    }, fps);
    this.intervalsArray.push(myInt1);
  }

  expressionWithAudio(charId, url, Frames, duration, fidelity, callback){
    let x = 0;
    let count = 1;
    let fps = 1000/fidelity;
    // start animation with interval
    let myInt1 = setInterval(()=>{
      $("#"+charId).css('background-image','url('+url+')');
      $("#"+charId).css('background-position',''+x+'px 0%');
      if(count == Frames){
        count = 1;
        x = 0;
      }else{
        count = count+1;
        x = x-960;
      }
    }, fps);
    this.intervalsArray.push(myInt1);
    let mySetTimeout = setTimeout(()=>{
      clearInterval(myInt1);
      callback();
    }, duration);
    this.timeOutsArray.push(mySetTimeout);
  }

  expressionWithoutAudio(charId, url, Frames, fidelity, callback){
    let x = 0;
    let count = 1;
    let fps = 1000/fidelity;
    // start animation with interval
    let myInt1 = setInterval(()=>{
      $("#"+charId).css('background-image','url('+url+')');
      $("#"+charId).css('background-position',''+x+'px 0%');
      if(count == Frames){
        clearInterval(myInt1);
        callback();
      }else{
        count = count+1;
        x = x-960;
      }
    }, fps);
    this.intervalsArray.push(myInt1);
  }


  clearAllIntervals(){
    clearInterval(this.defaultExpressionInterval);
    // Clear all set timeouts
    for(let j = 0; j< this.timeOutsArray.length; j++){
      clearTimeout(this.timeOutsArray[j]);
    }
    // Clear all set intervals
    for(let j = 0; j< this.intervalsArray.length; j++){
      clearInterval(this.intervalsArray[j]);
    }
    // Stop all played audios
    for(let i=0; i< this.playedAudiosArray.length; i++){
      this.playedAudiosArray[i].pause();
    }
    this.playedAudiosArray = [];
    this.intervalsArray = [];
    this.timeOutsArray = [];
  }

  ngOnDestroy() {
    this.clearAllIntervals();
    this.prevScore[0]  = this.myScore;
    this.prevScore[1]  = this.characterScore;
    this.prevScore[2]  = this.teamScore;
    this.lastScoreSave.emit({lastScore: this.prevScore});
  }

  influenseShow(){
    if(this.isInfluence)
      return true;
    else if(!this.isInfluence && this.responseDisable)
      return true;
    else if(!this.isInfluence && !this.responseDisable)
      return false;
  }

  continueMasterFeedback(){
    this.isMasterFeedback = false;
    if(this.feedbackAudio)
      this.feedbackAudio.pause();
  }

  isAudioAvailable(option){
    let name = option.audioFile;
    if(name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
      return true;
    }else {
      return false;
    }
  }

  playResponseAudio(option, optionNo){
    let name = option.audioFile;
    if(name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
      /*this.sceneAudios[name.split(".")[0]].play();
      this.sceneAudios[name.split(".")[0]].currentTime = 0;*/
      this.playGlobalAudio.emit({name: this.sceneAudios[name.split(".")[0]]});
      this.playedAudiosArray.push(this.sceneAudios[name.split(".")[0]]);
    }
  }

  stopResponseAudio(option, optionNo){
    let name = option.audioFile;
    if(name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
      this.sceneAudios[name.split(".")[0]].pause();
    }
  }

  stopOrPlayResponseAudio(e, option, optionNo){
    e.stopPropagation();
    let name = option.audioFile.split(".")[0];
    this.playResponseAudioFlag ? this.playResponseAudioFlag = false : this.playResponseAudioFlag = true;
    if(this.sceneAudios[name.split(".")[0]]){
      if(this.playResponseAudioFlag){
        $('#option'+optionNo).removeClass('volOff-icon');
        $('#option'+optionNo).addClass('volOn-icon');
        /*this.sceneAudios[name].play();
        this.sceneAudios[name].currentTime = 0;*/
        this.playGlobalAudio.emit({name: this.sceneAudios[name]});
        this.playedAudiosArray.push(this.sceneAudios[name]);
      }else {
        $('#option'+optionNo).removeClass('volOn-icon');
        $('#option'+optionNo).addClass('volOff-icon');
        this.sceneAudios[name].pause();
      }
    }else {
      $('#option'+optionNo).removeClass('volOn-icon');
      $('#option'+optionNo).addClass('volOff-icon');
    }

  }

  playInfluenceOptionAudio(selectedInfluence, option){
    let file = selectedInfluence[option+'Text_audio'];
    let name = file.split(".")[0];
    if(name && this.sceneAudios[name]) {
      /*this.sceneAudios[name].play();
      this.sceneAudios[name].currentTime = 0;*/
      this.playGlobalAudio.emit({name: this.sceneAudios[name]});
      this.playedAudiosArray.push(this.sceneAudios[name]);
    }
  }

  stopInfluenceOptionAudio(selectedInfluence, option){
    let file = selectedInfluence[option+'Text_audio'];
    let name = file.split(".")[0];
    if(name && this.sceneAudios[name]) {
      this.sceneAudios[name].pause();
    }
  }

  narratorCharacterPlay(){
    // true if audio is there.
    let name = this.characterSpeech.narratorsDialog.audioFile;
    let duration;
    if(name && this.sceneAudios[name.split(".")[0]]){
      duration = this.sceneAudios[name.split(".")[0]].duration * 1000;
      /*this.sceneAudios[name.split(".")[0]].currentTime = 0;
      this.sceneAudios[name.split(".")[0]].play();*/
      this.playGlobalAudio.emit({name: this.sceneAudios[name.split(".")[0]]});
      this.playedAudiosArray.push(this.sceneAudios[name.split(".")[0]]);
    }else {
      // duration = 5000;
      let txtForCnt = this.characterSpeech.narratorsDialog.text;
      let textLength = txtForCnt.length;
      if(textLength > 0){
        if(textLength < 8){
          let lowText = ((textLength / 2) * 1000) >= 1000 ? (textLength / 2) * 1000 : 750;
          duration = lowText;
          console.log("textLength---",textLength,"duration", duration);
        }else{
          let lowText = ((textLength / 8) * 1000) > 1000 ? (textLength / 8) * 1000 : 750;
          // duration = ((lowText / wordsPerMinute) * 60000) >= 1000 ? ((lowText / wordsPerMinute) * 60000) : lowText;
          duration = lowText;
          console.log("textLength---",textLength,"duration", duration);
        }
      }else{
        duration = 5000;
        console.log("textLength",textLength,"duration", duration);
      }
    }

    $('.advNarratorDialogue').text(this.characterSpeech.narratorsDialog.text);
    $('.advNarratorDialogue').css('display','block');
    let mySetTimeout = setTimeout(()=>{
      $('.advNarratorDialogue').css('display','none');
      $("#tooltip0").css("display","inline-block");
      clearInterval(this.defaultExpressionInterval);
      this.playCharacter(0);
    }, duration);
    this.timeOutsArray.push(mySetTimeout);
  }

  addCfgFeedBackText(){
    this.isCfgFeedBackInvalid = false;
    this.cfgFeedBackText = this.cfgFeedBackText && this.cfgFeedBackText.length > 0 ? this.cfgFeedBackText.trim() : '';
    if(this.cfgFeedBackText && this.cfgFeedBackText.length > 0){
      let obj = {
        name: 'feedback_text',
        data: this.cfgFeedBackText,
        is_completed: true
      };
      this.feedBackCFGText.emit({text: this.cfgFeedBackText, flag: 'feedback_text'});
      this.usrGameCfgData.push(obj);
      this.no_of_attempts += 1;
      this.cfgFeedBackFlag = false;
      this.isDisplayNotificationDivText.emit({flag: true});
      this.displaySummaryFeedback();
    }else{
      this.isCfgFeedBackInvalid = true;
    }
  }

  displaySummaryFeedback(){
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    this.cfgFeedBackFlag = false;
    this.isDisplayNotificationDivText.emit({flag: true});
    if(this.cfgContinueData){
      let x = this.cfgContinueData.x;
      let isEndOfGame = this.cfgContinueData.isEndOfGame;
      let i = this.cfgContinueData.i;
      let randonNum = this.cfgContinueData.randonNum;

      this.selectedGameResponse = this.selectedGameResponse.concat(i.id[i.id.length-1]);
      let score = this.myScore+":"+this.characterScore;
      let nextLink;
      if(randonNum < parseInt(x[0]))
        nextLink = 1;
      else
        nextLink = 2;
      this.gameFinished.emit({finished: true, Score: score, Path: i.id, prevScore: this.prevScore, Choice: this.currentGameChoices, Responses: this.selectedGameResponse, influenceCounter: this.influenceCounter, lastThreeResponse: this.lastThreeResponse, nextLink: nextLink});
      this.lastScore[0]  = this.myScore;
      this.lastScore[1]  = this.characterScore;
      this.lastScore[2]  = this.teamScore;
      this.lastScoreSave.emit({lastScore: this.lastScore});
      this.isLastNode = true;
      if(this.screenOrientataion == 90 && this.screenWidth < 1000){
        $(".mobileSlideHeader").removeClass("headerShow");
        $('.responseBgContainer').css('top','0%');
        $('.gameContainer').css('height','calc(100vh - 66px)');
        $('.commonModalFooter').css('display','flex');
      }
      $('.showSingle').removeClass('modalFooterActiveBtn');
      $('#showSingle6').addClass('modalFooterActiveBtn');
      for(let j=0; j< this.characterSpeech.summaryFeedbacks.length; j++){
        if(this.characterSpeech.summaryFeedbacks[j].id == i.id){
          this.summaryFeedback = this.characterSpeech.summaryFeedbacks[j].text;
          break;
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/Screens/advance-game/advance-game.component.ts